(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7242],{

/***/ 69241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ support_plan_comparison; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/SupportPlanComparison/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var copy = {
  heading: "Which plan is right for me?",
  description: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
      children: "At Segment, we want to equip you with the expertise you need to be successful. For access to technical support and additional Support resources, we offer plans to fit your unique needs."
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
      children: "Professional Services is a separate offer that accelerates time to value with Segment advisory, jumpstart, and resident architect programs. It can be purchased in addition to any Support plan."
    })]
  })
};
var Hero_button = {
  text: "View Support Plans",
  url: "/support-plans/"
};

var Hero = function Hero() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* default */.ZP, {
      variant: "centered",
      copyVariant: "wide",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h1",
            variant: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextDescription, {
            tag: "h2",
            variant: "pExtraLarge",
            children: copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          href: (0,getAbsoluteUrl/* default */.Z)(Hero_button.url, pageConfig),
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: Hero_button.text
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1me770i1"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledCopyTextDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "e1me770i0"
} : 0)( true ? {
  name: "1yb8huf",
  styles: "p:not(:first-of-type){margin-top:24px;}"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/views/SupportPlanComparison/components/TalkToAnExpert/TalkToAnExpert.tsx


function TalkToAnExpert_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var TalkToAnExpert_copy = {
  heading: "Talk to an expert",
  description: "Learn how our support expertise can help you reduce risk."
};
var TalkToAnExpert_button = {
  text: "Talk to an expert",
  url: "/demo/"
};

var TalkToAnExpert = function TalkToAnExpert() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TalkToAnExpert_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h3",
            variant: "h2",
            children: TalkToAnExpert_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pLarge",
            children: TalkToAnExpert_copy.description
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cta, {
          color: "primary",
          variant: "filled",
          size: "large",
          href: (0,getAbsoluteUrl/* default */.Z)(TalkToAnExpert_button.url, pageConfig),
          children: TalkToAnExpert_button.text
        })]
      })
    })
  });
};

/* harmony default export */ var TalkToAnExpert_TalkToAnExpert = (TalkToAnExpert);

var TalkToAnExpert_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1bhn0vr2"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1bhn0vr1"
} : 0)(Section/* Wrapper */.im, "{row-gap:0;}" + ( true ? "" : 0));

var Cta = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "e1bhn0vr0"
} : 0)( true ? {
  name: "afry63",
  styles: "margin:24px 0 0"
} : 0);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__(95922);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TablePricing/index.tsx + 31 modules
var TablePricing = __webpack_require__(16410);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TablePricing/Icons/index.ts + 1 modules
var Icons = __webpack_require__(88610);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/views/SupportPlanComparison/components/PricingTable/PricingTable.tsx



function PricingTable_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var data = [["Will you provide incident support and facilitate provisioning of product code level fixes if encountered?", true, true, true, true, true], ["Will you provide assistance with new feature releases?", true, true, true, true, true], ["Will you provide assistance with documented implementation & product guidance?", true, true, true, true, true], ["Will you help me with technical troubleshooting post implementation?", true, true, true, true, true], ["Do you provide SLO on response and engagement time?", "*Business Tier Only", true, true, true, false], ["Will you join our project kick-off meeting?", false, false, false, true, true], ["Will you help me map our requirements to best practice implementation directives?", false, false, false, false, true], ["Will you own the delivery of my Segment project?", false, false, false, false, true], ["Will you come on site?", false, false, false, false, true], ["Will you provide system & performance tuning?", false, false, false, false, true], ["Will you perform Health Checks on my Segment workspace?", false, false, false, false, true], ["Will you troubleshoot my custom code for me?", false, false, false, false, true], ["Will you own the technical design of my custom code for me?", false, false, false, false, true], ["Will you build my customization for me from scratch?", false, false, false, false, true], ["Will you provide training to help me understand how to use Segment?", false, false, false, false, true], ["Will you write custom queries or build custom reports for my data?", false, false, false, false, true]];

var PricingTable = function PricingTable() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var isDesktopResolution = (0,useMatchMedia/* default */.Z)(theme.breakpoints.up("xxl", false), true);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    sticky: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TablePricing/* default */.ZP, {
        columns: 6,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TablePricing/* Header */.h4, {
          sticky: true,
          pinFirst: true,
          tokens: {
            top: isDesktopResolution ? 76 : 0
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* HeaderCell */.qN, {
            title: "Activity",
            headingVariant: "h5",
            colSpan: 3
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* HeaderCell */.qN, {
            title: "Standard Support",
            headingVariant: "h5"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* HeaderCell */.qN, {
            title: "Advanced Support",
            headingVariant: "h5"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* HeaderCell */.qN, {
            title: "Premium Support",
            headingVariant: "h5"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* HeaderCell */.qN, {
            title: "Premium + Support",
            headingVariant: "h5"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* HeaderCell */.qN, {
            title: "Professional Services",
            headingVariant: "h5",
            tokens: {
              headingColor: theme.palette.twilio.boysenberry[60]
            }
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* Body */.uT, {
          zebra: "odd",
          children: data.map(function (_ref) {
            var _ref2 = (0,toArray/* default */.Z)(_ref),
                heading = _ref2[0],
                row = _ref2.slice(1);

            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* Row */.X2, {
              header: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* RowHeader */.yD, {
                tokens: {
                  variantDesktop: "pSmall",
                  variantMobile: "textRegularSmall"
                },
                children: heading
              }),
              children: row.map(function (cell, i) {
                return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TablePricing/* Cell */.bL, {
                  children: [Boolean(cell) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack, {
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icons/* CheckIcon */.n, {
                      color: row.length - 1 === i ? theme.palette.twilio.boysenberry[60] : undefined
                    }), typeof cell === "string" && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                      variant: "textTiny",
                      children: cell
                    })]
                  }), !cell && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                    variant: "pMedium",
                    tokens: {
                      color: theme.palette.twilio.gray[80]
                    },
                    children: "\u2014"
                  })]
                }, "".concat(heading, "-").concat(cell, "-").concat(i));
              })
            }, heading);
          })
        })]
      })
    })
  });
};

/* harmony default export */ var PricingTable_PricingTable = (PricingTable);

var Stack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e7p9wvx1"
} : 0)( true ? {
  name: "1ypg9o2",
  styles: "display:flex;flex-direction:column;align-items:center;gap:10px"
} : 0);

var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e7p9wvx0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ./src/views/SupportPlanComparison/SupportPlanComparison.tsx












var SupportPlanComparison = function SupportPlanComparison() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Support | Twilio Segment",
      pageDescription: "Learn more about which Twilio Segment support plan is right for you.",
      themeColor: theme.palette.twilio.gray[10],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PricingTable_PricingTable, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TalkToAnExpert_TalkToAnExpert, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

/* harmony default export */ var SupportPlanComparison_SupportPlanComparison = (SupportPlanComparison);

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1f4awj10"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/pages/support-plan-comparison.tsx



var support_plan_comparison_SupportPlanComparison = function SupportPlanComparison() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SupportPlanComparison_SupportPlanComparison, {});
};

/* harmony default export */ var support_plan_comparison = (support_plan_comparison_SupportPlanComparison);

/***/ }),

/***/ 17811:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support-plan-comparison",
      function () {
        return __webpack_require__(69241);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95922:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64034);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17602);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57211);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42330);




function _toArray(arr) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,7209,1382,4136,8392,2073,7096,2429,7303,8187,7960,5818,9774,2888,179], function() { return __webpack_exec__(17811); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);